export const DEFAULT_LOCALE = 'en';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zh-Hant'];

/** 暂时禁用日语：缓存或切换为 ja 时回落到 en */
export function resolveLocale(locale: string | null | undefined): string {
  const normalized = (locale || '').trim();
  if (!normalized || normalized === 'ja') {
    return DEFAULT_LOCALE;
  }
  return LOCALE_LIST.includes(normalized) ? normalized : DEFAULT_LOCALE;
}
export const VIDEO_EXTENSIONS = [
  '.mp4',
  '.mov',
  '.avi',
  '.wmv',
  '.flv',
  '.mpeg',
  '.mpg',
  '.m4v',
  '.webm',
  '.ogg',
  '.ogv',
  '.mkv'
];
export const LOCALE_MAP = {
  en: 'en',
  ja: 'ja',
  ko: 'ko-KR',
  zh: 'zh-CN',
  'zh-Hant': 'zh-Hant'
};
